/*
  La marca de «plan de prueba» vive en el modelo (`Plan.tier`, schema.prisma): `DEMO` topa
  a las empresas demo (Mini Prixia) y `TRIAL` es la Prueba Gratuita. Nunca por nombre: un
  plan se puede renombrar. Recorrido 3-nov: convertir una prueba no ofrece otra prueba.
*/
const TIERS_DE_PRUEBA: readonly string[] = ['DEMO', 'TRIAL'];

export function esPlanDePrueba(plan: { tier: string }): boolean {
  return TIERS_DE_PRUEBA.includes(plan.tier);
}

/** Los planes a los que se puede pasar una prueba («Pasar al plan completo»). */
export function planesParaConvertir<P extends { tier: string }>(planes: readonly P[]): P[] {
  return planes.filter((p) => !esPlanDePrueba(p));
}
